import GoogleLogin from './GoogleLogin';

export default GoogleLogin;
